import React from 'react';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';

const Support = () => {
  return (
    <div className="support-page">
      <div className="support-container">
        <h1 className="page-title">SUPPORT CENTER</h1>
        <p className="page-intro">
          Have questions? We're here to help. Contact our support team for any inquiries about 
          the World Financial Award.
        </p>

        <div className="support-content">
          <section className="contact-methods">
            <div className="contact-card">
              <Mail className="contact-icon-large" />
              <h3>Email Us</h3>
              <p>info@worldfinancialaward.com</p>
              <p className="contact-note">We typically respond within 24 hours</p>
            </div>

            <div className="contact-card">
              <Clock className="contact-icon-large" />
              <h3>Business Hours</h3>
              <p>Monday - Friday</p>
              <p>9:00 AM - 6:00 PM GMT</p>
            </div>
          </section>

          <section className="faq-section">
            <h2>Frequently Asked Questions</h2>
            
            <div className="faq-item">
              <h3>How can I nominate my company?</h3>
              <p>
                You can nominate your company by filling out the entry form on our "Enter" page. 
                Select the appropriate category and provide the required information about your company.
              </p>
            </div>

            <div className="faq-item">
              <h3>What are the eligibility criteria?</h3>
              <p>
                Companies from all financial sectors are eligible to apply. We evaluate based on 
                innovation, customer service, market impact, and overall excellence in your category.
              </p>
            </div>

            <div className="faq-item">
              <h3>When will winners be announced?</h3>
              <p>
                Winners are announced at our annual ceremony. For 2025, the ceremony will be held 
                virtually on December 22-23, 2025.
              </p>
            </div>

            <div className="faq-item">
              <h3>Is there a fee to enter?</h3>
              <p>
                Please contact our team for information about entry fees and the registration process.
              </p>
            </div>

            <div className="faq-item">
              <h3>Can I nominate for multiple categories?</h3>
              <p>
                Yes, companies can submit nominations for multiple award categories. Each nomination 
                requires a separate application.
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Support;